import * as React from 'react';

interface Props {
    isEdited: boolean;
    onSave: () => void;
    onCancel: () => void;
    onEdit: () => void;
    isSaveDisabled?: boolean;
}

class Edit extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <div>
                {this.renderEditButton()}
                {this.renderEditOptions()}
            </div>
        );
    }

    private renderEditButton = (): JSX.Element | null =>
        !this.props.isEdited ? (
            <button className="button-edit" onClick={this.props.onEdit}>
                Edit
            </button>
        ) : null;

    private renderEditOptions = (): JSX.Element | null =>
        this.props.isEdited ? (
            <>
                <button className="button-save" onClick={this.props.onSave} disabled={this.props.isSaveDisabled}>
                    Save
                </button>
                <button className="button-cancel link-button" onClick={this.props.onCancel}>
                    Cancel
                </button>
            </>
        ) : null;
}

export default Edit;



// WEBPACK FOOTER //
// ./src/view/common/Edit.tsx